import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { colors } from '../../styles';
import { Icon } from '../icons';

export interface Props {
  className?: string;
  showIcon?: boolean;
  message: JSX.Element | React.ComponentClass | string;
}

class WarningAlert extends React.Component<Props, any> {
  public render() {
    const { className, message, showIcon } = this.props;
    return (
      <div className={className}>
        {showIcon && <Icon icon="info" baseColor={'rgba(255, 170, 0, .7)'} />}
        {message}
      </div>
    );
  }
}

export default styled(WarningAlert)`
  background: rgba(255, 170, 0, 0.1);
  border: 1px solid rgba(255, 170, 0, 0.5);
  border-radius: 6px;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    padding-right: 0.5rem;
  }
`;
